import {Section} from '@primer/react-brand/esm'
import {FlexSuiteIntroLogos} from '../../../components/FlexSuiteIntroLogos'
import {FlexSuiteStatistics} from '../../../components/FlexSuiteStatistics'
import type {IntroSectionProps} from './types'

export function IntroSection({
  introLogos,
  introLogoLink,
  introStats,
  logobarOptions,
  logoSuiteOptions,
}: IntroSectionProps) {
  if (!introLogos?.length && !introStats?.length) return null

  const takeoverButton =
    logobarOptions?.takeoverButton ??
    (introLogoLink?.fields.href ? {label: introLogoLink.fields.text, href: introLogoLink.fields.href} : undefined)

  return (
    <Section fullWidth paddingBlockEnd="none" paddingBlockStart="none">
      <FlexSuiteIntroLogos
        logos={introLogos}
        logobarOptions={{
          ...logobarOptions,
          takeoverButton,
        }}
        logoSuiteOptions={logoSuiteOptions}
        hasTopBorder
      />
      <FlexSuiteStatistics stats={introStats} />
    </Section>
  )
}
